import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
};

const RHFTextField = forwardRef<HTMLInputElement, Props>(({ name, helperText, ...other }, ref) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          inputRef={ref} // 🔹 ref를 inputRef로 전달
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value ?? ''}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
});

export default RHFTextField;
